export default __webpack_public_path__ + "static/media/twitter.400cae1c.svg";